module.exports = "/static/images/ARI-logo--icon--black.svg";